const renameLoginMenuItem = async () => {
  if (!siteData.isLoggedIn) {
    const link = document.querySelector(".menu-item-807 a");
    link.innerHTML = "Login / Register";
  }
};

const myAccountMenuItem = async () => {
  if (!siteData.isLoggedIn) {
    const links = document.querySelectorAll(".menu-item-807");
    for (const link of links) {
      link.remove();
    }
  }
};

myAccountMenuItem();
